/**
 * Test IDs for QA automation.
 */
export const testIds = {
  compartmentsFormIdentifier: "compartments-form-identifier",
  compartmentsFormCapacity: "compartments-form-capacity",
  compartmentsFormMinVolume: "compartments-form-min-volume",
  compartmentsFormMaxVolume: "compartments-form-max-volume",
  compartmentsFormHeavyOnly: "compartments-form-heavy-only",
  compartmentsFormDoubleBulkhead:
    "compartments-form-double-bulkhead",
  compartmentsFormRemove: "compartments-form-remove",
} as const;
